import { render, staticRenderFns } from "./AppleIcon.vue?vue&type=template&id=036b50da"
import script from "./AppleIcon.vue?vue&type=script&lang=js"
export * from "./AppleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports